import React from 'react';
import { SportFilter, StatusFilter } from '../utils/eventUtils';
import styles from './EventFilters.module.css';

interface EventFiltersProps {
    sportTab: SportFilter;
    statusFilter: StatusFilter;
    searchQuery: string;
    favoritesOnly: boolean;
    favoriteCount: number;
    resultCount: number;
    cricketCount: number;
    footballCount: number;
    onSportChange: (tab: SportFilter) => void;
    onStatusChange: (status: StatusFilter) => void;
    onSearchChange: (query: string) => void;
    onFavoritesToggle: () => void;
    onRefresh?: () => void;
    refreshing?: boolean;
}

const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
    { value: 'all', label: 'সব' },
    { value: 'live', label: 'লাইভ' },
    { value: 'scheduled', label: 'আসন্ন' },
    { value: 'completed', label: 'শেষ' },
];

const EventFilters: React.FC<EventFiltersProps> = ({
    sportTab,
    statusFilter,
    searchQuery,
    favoritesOnly,
    favoriteCount,
    resultCount,
    cricketCount,
    footballCount,
    onSportChange,
    onStatusChange,
    onSearchChange,
    onFavoritesToggle,
    onRefresh,
    refreshing = false,
}) => (
    <div className={styles.wrapper}>
        <div className={styles.searchRow}>
            <div className={styles.searchBox}>
                <span className={styles.searchIcon} aria-hidden="true">🔍</span>
                <input
                    type="search"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    placeholder="ম্যাচ বা দল খুঁজুন..."
                    className={styles.searchInput}
                    aria-label="ইভেন্ট খুঁজুন"
                />
            </div>
            {onRefresh && (
                <button
                    type="button"
                    className={`${styles.refreshBtn} ${refreshing ? styles.spinning : ''}`}
                    onClick={onRefresh}
                    disabled={refreshing}
                    aria-label="রিফ্রেশ"
                >
                    ↻
                </button>
            )}
        </div>

        <div className={styles.tabs} role="tablist" aria-label="খেলার ধরন">
            {([
                { id: 'all' as SportFilter, label: 'সব', count: cricketCount + footballCount },
                { id: 'cricket' as SportFilter, label: 'ক্রিকেট', count: cricketCount },
                { id: 'football' as SportFilter, label: 'ফুটবল', count: footballCount },
            ]).map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={sportTab === tab.id}
                    className={`${styles.tab} ${sportTab === tab.id ? styles.tabActive : ''}`}
                    onClick={() => onSportChange(tab.id)}
                >
                    {tab.label}
                    <span className={styles.count}>{tab.count}</span>
                </button>
            ))}
        </div>

        <div className={styles.filterRow}>
            <div className={styles.statusFilters} role="group" aria-label="স্ট্যাটাস ফিল্টার">
                {STATUS_OPTIONS.map((opt) => (
                    <button
                        key={opt.value}
                        type="button"
                        className={`${styles.chip} ${statusFilter === opt.value ? styles.chipActive : ''}`}
                        onClick={() => onStatusChange(opt.value)}
                        aria-pressed={statusFilter === opt.value}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>
            <button
                type="button"
                className={`${styles.favChip} ${favoritesOnly ? styles.chipActive : ''}`}
                onClick={onFavoritesToggle}
                aria-pressed={favoritesOnly}
            >
                ★ পছন্দ ({favoriteCount})
            </button>
        </div>

        <p className={styles.resultCount}>{resultCount}টি ইভেন্ট পাওয়া গেছে</p>
    </div>
);

export default EventFilters;
